<template>
  <div>
    <v-dialog v-model="darAlta" hide-overlay persistent width="500">
      <v-card color="headeryfooter">
        <v-system-bar color="headeryfooter darken-2" dark>
          <v-spacer></v-spacer>
          <v-icon @click="cancelarNuevo">mdi-close</v-icon>
        </v-system-bar>
        <v-container>
          <Alta
            :titulo="nuevoTxt"
            :modulo="modulo"
            :propId="propId"
            :propDescripcion="propDescripcion"
          ></Alta>
        </v-container>
      </v-card>
    </v-dialog>
    <v-card color="fondoformulario">
      <v-card-title>
        <v-col md="8">
          <v-text-field
            v-model="busqueda"
            prepend-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            clearable
            clear-icon="mdi-close-circle-outline"
          ></v-text-field>
        </v-col>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn @click="setNuevo" small fab dark v-on="on" color="teal">
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ nuevoTxt }}</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <h3 class="text-center">{{ singular }}</h3>
        <v-divider class="mb-2"></v-divider>
        <div style="max-height: 50vh" class="overflow-y-auto">
          <Modificar
            v-for="entidad in ListaFiltrada"
            :key="entidad[propId]"
            :modulo="modulo"
            :propId="propId"
            :propDescripcion="propDescripcion"
            :entidad="entidad"
          ></Modificar>
        </div>
        <div class="text-center mt-4">
          <v-pagination v-model="pagina" :length="paginas"></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Alta from "./Alta";
import Modificar from "./Modificar";
export default {
  components: {
    Alta,
    Modificar,
  },
  props: ["modulo", "nuevoTxt", "propId", "propDescripcion", "singular"],
  data() {
    return {
      pagina: 1,
      tamaniopagina: 50,
      busqueda: "",
      filtrada: [],
      headers: [
        {
          text: this.singular,
          value: this.propDescripcion,
        },
        {
          text: "Id",
          value: this.propId,
        },
      ],
    };
  },
  computed: {
    Lista() {
      return this.$store.state[this.modulo].Lista;
    },
    paginas() {
      return Math.floor(this.filtrada.length / this.tamaniopagina);
    },
    ListaFiltrada() {
      let busqueda = this.busqueda || "";

      this.filtrada = this.Lista.filter(
        (x) =>
          x[this.propId] > 0 &&
          x[this.propDescripcion]
            .toUpperCase()
            .indexOf(busqueda.toUpperCase()) > -1
      );
      return this.filtrada.slice(
        (this.pagina - 1) * this.tamaniopagina,
        (this.pagina) * this.tamaniopagina
      );
    },
    Seleccionado() {
      return this.$store.state[this.modulo].Seleccionado;
    },
    darAlta() {
      if (this.Seleccionado !== undefined) {
        if (this.Seleccionado[this.propId] === 0) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    selectPorId() {
      this.$store.dispatch(this.modulo + "/selectPorId");
    },
    setNuevo() {
      this.$store.dispatch(this.modulo + "/setNuevo");
    },
    save(item) {
      this.guardar();
    },
    cancelarNuevo() {
      this.selectPorId(-1);
    },
    open(id) {
      this.selectPorId(id);
    },
  },
  watch: {
    busqueda() {
      this.pagina = 1;
    },
  },
};
</script>

<style>
/* .v-text-field__details {
  position: absolute;
  margin: 12px 100px;
} */
</style>
